import {createSlice} from '@reduxjs/toolkit';
import {initialIntermediateCeilingState} from './initialIntermediateCeilingState';
import {setLid} from "../lid/lidSlice";

const intermediateCeilingSlice = createSlice({
    name: 'intermediateCeiling',
    initialState: null,
    reducers: {
        setIntermediateCeiling: (state) => state ?? initialIntermediateCeilingState,
        unsetIntermediateCeiling: () => null,
        addBlockOut: (state, action) => {
            const {blockOut} = action.payload;

            state.blockOuts.push(blockOut);
        },
        removeBlockOut: (state, action) => {
            const {id} = action.payload;

            state.blockOuts = state.blockOuts.filter(
                blockOut => blockOut.id !== id
            );
        },
        moveBlockOut: (state, action) => {
            const {id, x, y} = action.payload;

            state.blockOuts = state.blockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, x, y};
            });
        },
        resizeBlockOut: (state, action) => {
            const {id, width, height} = action.payload;

            state.blockOuts = state.blockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, width, height};
            });
        },
        addCircularBlockOut: (state, action) => {
            const {blockOut} = action.payload;

            state.circularBlockOuts.push(blockOut);
        },
        removeCircularBlockOut: (state, action) => {
            const {id} = action.payload;

            state.circularBlockOuts = state.circularBlockOuts.filter(
                blockOut => blockOut.id !== id
            );
        },
        moveCircularBlockOut: (state, action) => {
            const {id, x, y} = action.payload;

            state.circularBlockOuts = state.circularBlockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, x, y};
            });
        },
        resizeCircularBlockOut: (state, action) => {
            const {id, diameter} = action.payload;

            state.circularBlockOuts = state.circularBlockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, diameter, outerDiameter: diameter};
            });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(setLid, (state) => state ? initialIntermediateCeilingState : null)
    }
})

export const {
    setIntermediateCeiling,
    unsetIntermediateCeiling,
    addBlockOut,
    removeBlockOut,
    moveBlockOut,
    resizeBlockOut,
    addCircularBlockOut,
    removeCircularBlockOut,
    moveCircularBlockOut,
    resizeCircularBlockOut
} = intermediateCeilingSlice.actions

export default intermediateCeilingSlice.reducer